export type ScrollAxis = "x" | "y";

export type ScrollContainer = HTMLElement | string | null;

export interface ScrollCenterOptions {
	axis: ScrollAxis;
	behavior: ScrollBehavior;
	container: ScrollContainer;
}

const resolveContainer = (container: ScrollContainer): Element | Window => {
	if (!container) return window;
	return typeof container === "string" ? document.querySelector(container) || window : container;
};

export const scrollToCenter = (target: HTMLElement, { axis, behavior, container }: ScrollCenterOptions) => {
	const scrollContainer = resolveContainer(container);
	const box = scrollContainer === window ? null : (scrollContainer as Element);
	const options: ScrollToOptions = { behavior };

	if (axis === "x") {
		const containerWidth = box ? box.clientWidth : window.innerWidth;
		const scrollLeft = box ? target.getBoundingClientRect().left - box.getBoundingClientRect().left + box.scrollLeft : target.offsetLeft;
		options.left = Math.max(0, scrollLeft - (containerWidth - target.offsetWidth) / 2);
	} else {
		const containerHeight = box ? box.clientHeight : window.innerHeight;
		const scrollTop = box ? target.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop : target.offsetTop;
		options.top = Math.max(0, scrollTop - (containerHeight - target.offsetHeight) / 2);
	}

	try {
		scrollContainer.scrollTo(options);
	} catch (error) {
		console.error("Scroll error:", error);
	}
};
